import { useState } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function Alerts(data) {
  const [open, setOpen] = useState(true);

  if (!open) {
    return null;
  }

  return (
    <Stack sx={{ width: "100%" }} spacing={2}>
      <Alert
        severity={data.data.severity}
        action={
          <IconButton
            aria-label="zamknij"
            onClick={() => setOpen(false)}
            sx={{
              color: "inherit",
              fontSize: "1.5rem",
              fontWeight: "bold",
              padding: "6px",
              marginRight: "2px",
              "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.12)",
              },
            }}
          >
            <CloseIcon fontSize="large" />
          </IconButton>
        }
      >
        <AlertTitle>{data.data.title}</AlertTitle>
        {data.data.info}
      </Alert>
    </Stack>
  );
}
